import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import "fontsource-muli";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Color from "../../../utils/Color";

const CustomTextInputOtp = ({
  classes,
  design,
  title,
  textstyle,
  startAdornment,
  endAdornment,
  onChange = () => {},
  value,
  type,
  placeholder,
  required,
  disabled = false,
  defaultValue,
  autoFocus = false,
  children,
  id = "outlined-input",
  fullWidth = false,
  multiline = false,
  errorMessage = "",
  errorTextStyle,
  notchedOutlineStyle,
  rootStyle,
  error = false,
  borderline,
  tooltip = null,
  borderNone,
  maxLengthFlag,
  maxL,
  ...props
}) => {
  return (
    <div>
      {title ? (
        tooltip ? (
          <div className={classes.tooltipLabelContainer}>
            <CustomText className={`${classes.textStyle} ${textstyle}`}>
              {title}
            </CustomText>
            {tooltip}
          </div>
        ) : (
          <CustomText className={`${classes.textStyle} ${textstyle}`}>
            {title}
          </CustomText>
        )
      ) : (
        false
      )}
      <OutlinedInput
        autoComplete="new-password"
        className={`${classes.root} ${design}`}
        id={id}
        value={value}
        onChange={onChange}
        type={type}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        defaultValue={defaultValue}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        multiline={multiline}
        error={error}
        classes={{
          root: !error
            ? `${classes.root}  ${rootStyle}`
            : `${classes.errorRoot}`,
          focused: classes.focused,
          notchedOutline: borderline !== true
            ? `${classes.notchedOutline} ${notchedOutlineStyle}`
            : `${classes.notchedOutlineNone} ${notchedOutlineStyle}`,
          input: classes.inputStyle,
        }}
        inputProps={{ maxLength: 2 }}
        {...props}
      />
      {error ? (
        <CustomText className={`${classes.errorTextStyle} ${errorTextStyle}`}>
          {errorMessage}
        </CustomText>
      ) : (
        false
      )}
    </div>
  );
};

const styles = {
  root: {
    // marginBottom: 18,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "& $notchedOutlineV2": {
      borderWidth: 1,
      border: "none",
      backgroundColor:"#f5f5f5"
    },
    "&:hover $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.textInputColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.textInputColor,
    },
    "& input::placeholder": {
      color: "#303030",
      fontWeight:"bold"
    },
  },
  errorRoot: {
    // marginBottom: 0,
    "& $notchedOutline": {
      borderWidth: 1,
    },
    "&:hover $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.errorBorderColor,
    },
    "&$focused $notchedOutline": {
      border: "solid 1px",
      borderColor: Color.errorBorderColor,
    },
  },
  textStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    textAlign:"center"
  },
  buttonStyle: {},
  focused: {},
  notchedOutline: {},
  notchedOutlineNone: {
    //border: 0,
    border: "none",
    backgroundColor:"#DCDCDC",
    opacity:0.3
  },
  inputStyle: {
    textTransform: "none",
    ...getFontWeight("600"),
    fontFamily: "Muli",
    fontSize: 15,
    color: Color.primaryTextColor,
    textAlign:"center"
  },
  errorTextStyle: {
    textTransform: "none",
    ...getFontWeight("normal"),
    fontFamily: "Muli",
    ...getFontSize("xxsmall"),
    color: Color.errorBorderColor,
    marginTop: "0.7em",
  },
  tooltipLabelContainer: {
    display: "flex",
    alignItems: "center",
    
  },
};
export default withStyles(styles)(CustomTextInputOtp);
